import { render, staticRenderFns } from "./user.vue?vue&type=template&id=15e13bfe&scoped=true"
import script from "./user.vue?vue&type=script&lang=js"
export * from "./user.vue?vue&type=script&lang=js"
import style0 from "./user.vue?vue&type=style&index=0&id=15e13bfe&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e13bfe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15e13bfe')) {
      api.createRecord('15e13bfe', component.options)
    } else {
      api.reload('15e13bfe', component.options)
    }
    module.hot.accept("./user.vue?vue&type=template&id=15e13bfe&scoped=true", function () {
      api.rerender('15e13bfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/user.vue"
export default component.exports